// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___h8nCV";
var _2 = "styles-module__searchButton___mncYl";
export { _1 as "container", _2 as "searchButton" }
